import Vue from 'vue';
import PreviewImg from './previewImg.vue';

let previewImgInstance;
const PreviewImgConstructor = Vue.extend(PreviewImg);

const initPreviewImgInstance = () => {
  previewImgInstance = new PreviewImgConstructor();
  document.body.appendChild(previewImgInstance.$mount().$el);
};

export default options => {
  if (!previewImgInstance) {
    initPreviewImgInstance();
  }
  Object.assign(previewImgInstance, options);

  return previewImgInstance.show(vm => {
    previewImgInstance = null;
  });
};
